// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"e8-z"};